import { render, staticRenderFns } from "./gStar.vue?vue&type=template&id=0868ad25&scoped=true&"
import script from "./gStar.vue?vue&type=script&lang=js&"
export * from "./gStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0868ad25",
  null
  
)

export default component.exports